import React from "react";

const testimonials = [
  {
    text: "GreeNox has quickly become my top choice for a wholesome and fulfilling meal. Their dedication to sustainability, freshness, and high-quality ingredients truly stands out. It's more than just great food, it's a commitment to a healthier, greener lifestyle.",
    name: "Akash",
    img: "/img/Akash.jpg",
  },
  {
    text: "I've been a loyal GreeNox customer for over two years, and their delicious, nutritious dishes keep me coming back. Their plant-based menu has truly been a game-changer for my lifestyle, and every visit feels welcoming thanks to their warm and inviting atmosphere.",
    name: "Aditya Chaudhary",
    img: "/img/Aditya.jpg",
  },
  {
    text: "As a fitness enthusiast, I appreciate the protein-packed options at GreeNox. The Soya Paneer Rice Bowl is my favorite. It's both nutritious and delicious. Plus, the cleanliness and hygiene at their food production unit are top-notch.",
    name: "Adeesh",
    img: "/img/Adeesh.jpg",
  },
  {
    text: "As a fitness enthusiast, I truly value the protein-rich meals GreeNox offers. Their Soya Paneer Rice Bowl is my absolute favorite: nutritious, delicious, and perfectly balanced. I'm also consistently impressed by the exceptional hygiene and cleanliness maintained at their food production unit. GreeNox sets a high standard!",
    name: "Kinjalika Verma",
    img: "/img/Kinjalika.jpg",
  },
];

const QuoteIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 32 24" className="h-6 w-8 text-green-600/30" fill="currentColor">
    <path d="M0 24V14.4C0 6.4 4.3 1.6 12.8 0l1.4 3.2C9.6 4.6 7.4 7.4 7.2 11.2H13V24H0zm18 0V14.4C18 6.4 22.3 1.6 30.8 0l1.4 3.2c-4.6 1.4-6.8 4.2-7 8H31V24H18z" />
  </svg>
);

export const Testimonials = () => {
  return (
    <section className="freshmealplan">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:py-20 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-12">
        <div className="text-center lg:sticky lg:top-24 lg:self-start lg:text-left">
          <p className="story-hero-head mb-3 text-base font-bold uppercase tracking-wide text-gray-900 md:text-lg">
            What people say
          </p>
          <h2 className="story-hero-head text-[2rem] font-bold uppercase leading-[1.1] text-[#1f5c33] sm:text-[2.5rem] md:text-5xl">
            Real People,
            <br />
            Real Reviews
          </h2>
          <p className="mx-auto mt-5 max-w-md text-[15px] leading-relaxed text-gray-700 md:text-base lg:mx-0">
            Unpaid, unfiltered words from the students, professionals and
            fitness lovers who eat with us.
          </p>
        </div>

        {/* Mobile: swipeable row of cards. sm and up: two-column grid. */}
        <ul className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-4 sm:mx-0 sm:grid sm:grid-cols-2 sm:gap-6 sm:overflow-visible sm:px-0 sm:pb-0">
          {testimonials.map((t) => (
            <li
              key={t.name}
              className="flex w-[85%] shrink-0 snap-center flex-col rounded-3xl border border-[#1f5c33]/10 bg-white p-6 shadow-sm sm:w-auto md:p-7"
            >
              <QuoteIcon />
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-gray-700">
                {t.text}
              </blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-[#1f5c33]/10 pt-5">
                <img
                  src={t.img}
                  alt=""
                  loading="lazy"
                  className="h-12 w-12 rounded-full object-cover ring-2 ring-white"
                />
                <p className="font-semibold text-gray-900">{t.name}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Testimonials;
